export default "__VITE_ASSET__d4U9Wbfc__"